import { render, staticRenderFns } from "./VerifyPwzDodModal.vue?vue&type=template&id=654941ed&scoped=true&"
import script from "./VerifyPwzDodModal.vue?vue&type=script&lang=js&"
export * from "./VerifyPwzDodModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPwzDodModal.vue?vue&type=style&index=0&id=654941ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654941ed",
  null
  
)

export default component.exports